// note: general import
import * as React from "react";
import { Helmet } from "react-helmet";
import { useLocation, useParams } from "react-router-dom";

// note: component import
import { breadcrumbNameMap as title } from "components/NonReusable/BreadCrumb";

function HTMLTag({ children, rel = "" }) {
  const location = useLocation(),
    { pathname } = location,
    { id, detailId } = useParams();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {rel || title({ to: pathname, id, detailId })}{" "}
          {title({ to: pathname, id, detailId })?.length !== 0
            ? "- BIMA TENANT"
            : "BIMA TENANT"}
        </title>
        <link
          rel={rel || title({ to: pathname, id, detailId })}
          href={
            process.env.REACT_APP_AIMS_WEB_DOMAIN + window.location.pathname
          }
        />
        <meta
          name="BIMA TENANT"
          content="Asset Information Management System Connected Data Environment (CDE)"
        />
      </Helmet>
      {children}
    </>
  );
}

export default HTMLTag;
